import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Whatsapp } from '@styled-icons/boxicons-logos';
// components
import Title from '../../../components/Title';
import Button from '../../../components/Button';

// assets
import BankLogo from '../../../assets/img/BankLogo.png';
import { useStore } from '../../../context/appContext';
import { BC_WHATSAPP_NUM } from '../../../constants/defaults';
import useGAEventsTracker from '../../../utils/useGAEventsTrackers';

const ImgDiv = styled.div`
  grid-area: content;
  text-align: center;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  flex-grow: 1;
  justify-content: space-evenly;
  align-items: center;
  padding:1rem;
`;

const Img = styled.img`
  height: 4rem;
`;

const WhatsappCircle = styled.div`
  height: 3.5rem;
  width: 3.5rem;
  background-color: green;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -3.5rem !important;
`;

const WhatsappIcon = styled(Whatsapp)`
  height: 2.5rem;
  width: 2.5rem;
  color: white;
`;

const Text = styled.h5`
  font-size: 1.2rem;
  text-align: center;
  font-weight: normal;
`;

function End() {
  const { confirmationData } = useStore();

  const GAEventsTracker = useGAEventsTracker("End Page");
  useEffect(() => {
    GAEventsTracker("Visualiza pantalla Fin");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    window.opener = null;
    window.open('', '_self');
    window.close();
  };

  return (
    <>
      <Title grid="title">Revisá tu casilla de email</Title>
      <ImgDiv>
        <Text>Te enviamos el email a: {confirmationData.person_mail}</Text>
        <Img src={BankLogo} />
        <Text>Para más información, hablanos a nuestro WhatsApp Oficial</Text>
        <WhatsappCircle>
          <a href={`whatsapp://send?phone=${BC_WHATSAPP_NUM}`}>
            <WhatsappIcon />
          </a>
        </WhatsappCircle>
      </ImgDiv>

      <Button filled grid="buttons" onClick={handleClose}>
        Cerrar
      </Button>
    </>
  );
}

export default End;
